import _ from 'lodash';
import useDispensary from 'src/dispensary/hooks/use-dispensary';

export default function useDispensaryMenuSections() {
  const { dispensary, ...dispensaryApolloValues } = useDispensary();
  const menuSections = _.sortBy(dispensary?.menuSections, 'position');

  return { menuSections, ...dispensaryApolloValues };
}
